<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Privacy Policy</h3>
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Privacy Policy</li>
            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="terms-conditions-area pt-50 pb-70">
    <div class="container">
        <div class="single-content">
          <h3>Privacy Policy</h3>
           <p>At Seolytics, accessible from&nbsp;<a href="https://seolytics.org/">https://seolytics.org/</a>, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Seolytics and how we use it.</p>

<p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>

<p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Seolytics. This policy is not applicable to any information collected offline or via channels other than this website.</p>

<p>Consent</p>

<p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>

<p>Information we collect</p>

<p>The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.</p>

<p>If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>

<p>When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.</p>

<p>How we use your information</p>

<p>We use the information we collect in various ways, including to:</p>

<ul>
    <li>Provide, operate, and maintain our website</li>
    <li>Improve, personalize, and expand our website</li>
    <li>Understand and analyze how you use our website</li>
    <li>Develop new products, services, features, and functionality</li>
    <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
    <li>Send you emails</li>
    <li>Find and prevent fraud</li>
</ul>

<p>Log Files</p>

<p>Seolytics follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services&#39; analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users&#39; movement on the website, and gathering demographic information.</p>

<p>Advertising Partners Privacy Policies</p>

<p>You may consult this list to find the Privacy Policy for each of the advertising partners of Seolytics.</p>

<p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Seolytics, which are sent directly to users&#39; browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>

<p>Note that Seolytics has no access to or control over these cookies that are used by third-party advertisers.</p>

<p>Third Party Privacy Policies</p>

<p>Seolytics&#39;s Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>

<p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers&#39; respective websites.</p>

<p>CCPA Privacy Rights (Do Not Sell My Personal Information)</p>

<p>Under the CCPA, among other rights, California consumers have the right to:</p>

<p>Request that a business that collects a consumer&#39;s personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</p>

<p>Request that a business delete any personal data about the consumer that a business has collected.</p>

<p>Request that a business that sells a consumer&#39;s personal data, not sell the consumer&#39;s personal data.</p>

<p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>

<p>GDPR Data Protection Rights</p>

<p>We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>

<p>The right to access &ndash; You have the right to request copies of your personal data. We may charge you a small fee for this service.</p>

<p>The right to rectification &ndash; You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</p>

<p>The right to erasure &ndash; You have the right to request that we erase your personal data, under certain conditions.</p>

<p>The right to restrict processing &ndash; You have the right to request that we restrict the processing of your personal data, under certain conditions.</p>

<p>The right to object to processing &ndash; You have the right to object to our processing of your personal data, under certain conditions.</p>

<p>The right to data portability &ndash; You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</p>

<p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>

<p>Children&#39;s Information</p>

<p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>

<p>Seolytics does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>

<p>&nbsp;</p>
        </div>
      
    </div>
</div>

<div class="brand-logo-area">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img  style="height: 28px;width: 120px" src="https://seolytics.org/front-site/img/veriheal.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img  style="height: 28px;width: 120px" src="https://seolytics.org/front-site/img/drivezy.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img  style="height: 28px;width: 120px" src="https://seolytics.org/front-site/img/Housing.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img  style="height: 28px;width: 120px" src="https://seolytics.org/front-site/img/drivezy.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img  style="height: 28px;width: 120px" src="https://seolytics.org/front-site/img/Etmoney.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img  style="height: 28px;width: 120px" src="https://seolytics.org/front-site/img/khata.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>